import instance, { ADMIN_PREFIX } from 'services/api';
import {
  AssignTranslatorInput,
  TranslatorRequestListQuery,
  TranslatorRequestListResponse,
  TranslatorRequestRow
} from 'types/api/appointmentTranslators';

interface PaginatedEnvelope<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

/**
 * GET /api/v2/admin/appointment-translators/requests (cycle-27) —
 * pending translator requests with embedded appointment +
 * translator_plan. Coerces page 0-based → 1-based at boundary.
 */
export const fetchTranslatorRequests = async (
  query: TranslatorRequestListQuery
): Promise<TranslatorRequestListResponse> => {
  const params: Record<string, string | number> = {
    page: query.page ?? 1,
    limit: query.limit ?? 10
  };

  const res = await instance.get<PaginatedEnvelope<TranslatorRequestRow>>(
    `${ADMIN_PREFIX}/appointment-translators/requests`,
    { params }
  );

  return {
    results: res.data.data ?? [],
    total: res.data.total ?? 0
  };
};

/**
 * PUT /api/v2/admin/appointment-translators/:id — assign a translator
 * to the pending request. Body: { translator_id }.
 */
export const assignTranslator = (
  id: string | number,
  input: AssignTranslatorInput
): Promise<unknown> =>
  instance.put(`${ADMIN_PREFIX}/appointment-translators/${id}`, input);

/**
 * DELETE /api/v2/admin/appointment-translators/:id — soft-delete.
 */
export const deleteAppointmentTranslator = (
  id: string | number
): Promise<unknown> =>
  instance.delete(`${ADMIN_PREFIX}/appointment-translators/${id}`);
